import { noticeError } from 'app/api/analytics/reporting';
import { loadBrand, loadLocaleAndTheme } from './watson-config-action';
import { getSession } from '../redux-bridge/session/actions';
import { isConfigLoaded, isConfigOk } from './watson-config-selectors';
import { tryLoadProdServices } from '../redux-dev/dev-actions';
import { removeExpiredClasses } from '../redux-known-classes/known-class-actions';
import { getUserInfo, setJigsawHost } from '../redux-jigsaw/jigsaw-action';
import { isSessionPending } from '../redux-bridgesaw/bridgesaw-selectors';
import { tryResetOnboarding } from 'app/api/redux-ui/common/onboarding/actions';

function hasExternalScriptError() {
  return window.jigsawLoadError || window.bridgeLoadError;
}

export function initAppData() {
  return function(dispatch) {
    return dispatch(tryLoadProdServices()).then(() => dispatch(initData()));
  };
}

function initData() {
  return function(dispatch) {
    if (hasExternalScriptError()) {
      noticeError(
        window.bridgeLoadError ? 'Bridge Load Error' : 'Jigsaw Load Error'
      );
      dispatch(loadBrand()).then(() => dispatch(loadLocaleAndTheme()));
    } else {
      dispatch(removeExpiredClasses());
      // Config setup depends on the user's grade level, which comes from the session.
      // However, there is some brand info we need in order to fetch the session. So
      // let's do a minimal brand setup, get the session, then load everything else.
      dispatch(loadBrand())
        .then(() => dispatch(setJigsawHost()))
        .then(() => dispatch(getSession()))
        .then(() => dispatch(getUserInfo()))
        // Onboarding needs user info. Load before locale so we're sure it's done before content loads.
        .then(() => dispatch(tryResetOnboarding()))
        .then(() => dispatch(loadLocaleAndTheme()));
    }
  };
}

export const LOADING = 'LOADING';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export function getAppInitStatus(state) {
  const cfgLoaded = isConfigLoaded(state);
  const userLoading = isSessionPending(state);
  const scriptError = hasExternalScriptError();
  const cfgOk = isConfigOk(state);

  if (!cfgLoaded) {
    return LOADING;
  }

  if (cfgOk) {
    if (scriptError) {
      return ERROR;
    } else if (userLoading) {
      return LOADING;
    }
    return SUCCESS;
  } else {
    return ERROR;
  }
}



// WEBPACK FOOTER //
// ./src/app/api/redux-watson/app-init.js